import { TEMPLATE_STATUS_LABEL, type TemplateListStatus } from '../types';
import styles from './TemplateStatusPill.module.css';

interface TemplateStatusPillProps {
  status: TemplateListStatus;
}

/** Shared Draft/Available/Active status pill used by both the templates table and the editor header. */
export function TemplateStatusPill({ status }: TemplateStatusPillProps) {
  return (
    <span className={styles.pill} data-status={status}>
      <span className={styles.dot} />
      {TEMPLATE_STATUS_LABEL[status]}
    </span>
  );
}
